// @flow
import React from 'react';
// graphql
import { createFragmentContainer, graphql } from 'react-relay';
import { withRouter } from 'react-router-dom';
// material
import Paper from 'material-ui/Paper';
import FlatButton from 'material-ui/FlatButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
// categories editor
import CategoriesEditor from './CategoriesEditor';
// style
import '../ui/column.css';
import './categories.css';
import { styles } from '../../lib/styles';

const CategoriesApp = props => {
	const { history, viewer } = props;
	return (
		<Paper className="column--1-1">
			<header className="column--header">
				<h3 className="column--title-regular">Рубрики</h3>
				<FlatButton
					label="Создать рубрику"
					className="topics--button"
					style={styles.headerButton}
					primary
					icon={<ContentAdd />}
					onClick={() => history.replace('/category/new')}
				/>
			</header>
			<CategoriesEditor viewer={viewer} />
		</Paper>
	);
};

export default withRouter(
	createFragmentContainer(
		CategoriesApp,
		graphql`
			fragment CategoriesApp_viewer on Viewer @argumentDefinitions(section: { type: "ID!" }) {
				...CategoriesEditor_viewer @arguments(section: $section)
			}
		`,
	),
);



// WEBPACK FOOTER //
// src/components/categories/CategoriesApp.js